<script setup lang="ts">
  import { trans } from '@bv/utils';

  import CallAction from '../CallAction.vue';

  import HangupIcon from './HangupIcon.vue';
</script>

<template>
  <call-action
    class="bg-red-500 hover:bg-red-500/90"
    :title="trans('voip.calls.call_action.hangup_trans')"
  >
    <hangup-icon />
  </call-action>
</template>
